import Image1 from "../../../assets/images/set-sushu-pieces-close-up-concept.webp";
import Image2 from "../../../assets/images/pho.webp";
import Image3 from "../../../assets/images/catering.png";

import { IntroCard } from "./card";
import { PrimaryButton } from "../../Buttons";
export function Intro() {
  // function handleOrderButton() {
  //   window.open("https://tista-sushi.orderintelligence.no/", "_blank");
  // }
  function handleOrderButton() {
    window.open("https://hangs-sushi.orderintelligence.no/no/menu", "_blank");
  }
  return (
    <section className="my-48 ">
      <div>
        <h1 className="text-center">Vi Tilbyr</h1>
        <p className="text-center mt-6 styling-font">Japansk, Vietnamesisk og Thai Mat</p>
        <div className="flex flex-wrap justify-center text-primary text-xl text-center pt-32 ">
          <IntroCard
            image={Image1}
            title="Sushi"
            content="Vår sushimeny kombinerer de ferskeste ingrediensene for å skape håndlagde ruller, nigiri og sashimi. Nyt autentiske japanske smaker med en moderne vri i hver bit."
          />
          <IntroCard
            image={Image2}
            title="Asiatiske retter"
            content="Opplev en verden av smaker med våre livlige asiatiske retter, inspirert av kulinariske tradisjoner fra hele kontinentet. Fra smakfulle wokretter til trøstende nudler – hver rett er en smak av hjemmet."
          />
          <IntroCard
            image={Image3}
            title="Catering Sevice"
            content="Vi leverer smakfull mat til ditt arrangement! Perfekt for alle anledninger, med ferske ingredienser og ekte asiatiske smaker. Minimum 10 personer med prisen 4500kr. Kontakt oss å bestille."
          />
        </div>
        <div className="text-center my-12">
              <PrimaryButton label="vår meny" onClick={handleOrderButton} />
            </div>
      </div>
    </section>
  );
}
